import React from "react";
import PageTitle from "../../../layout/PageTitle";
import {useMutation, useQuery} from "@apollo/client";
import {AddButton, DeleteButton, EditButton} from "../../../helpers/ButtonHelper";
import ListTable from "../../shared/ListTable";
import {deleteCategoryMutation, getCategories} from "./CategoryQueries";
import {Container} from "react-bootstrap";
import {deleteItem,} from "../../../helpers/Api";
import {Link} from "react-router-dom";

const CategoriesList = () => {
  const {data} = useQuery(getCategories)
  const [deleteCall] = useMutation(deleteCategoryMutation, {refetchQueries: [getCategories]})

  const header = <tr>
    <th>Denumire</th>
    <th>Interval orar</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/categories/${item.id}`}>
          {item.name}
        </Link>
      </td>
      <td>{item.time}</td>
      <td className='actions'>
        <EditButton to={`/categories/${item.id}`}/>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)}/>
      </td>
    </tr>
  }

  return (
    <Container>
      <PageTitle title='Mesele zilei' buttons={<AddButton to='/categories/new'/>}/>
      <div className="row justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.categories} header={header} listItem={listItem}/>
        </div>
      </div>
    </Container>
  )
};

export default CategoriesList;